import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router } from '@angular/router';

import { FeatureToggleService } from './feature-toggle.service';

interface FeatureToggleRouteData {
  readonly featureFlag?: string;
  readonly redirectUrl?: string;
}

export function featureToggleGuard(route: Route | ActivatedRouteSnapshot): boolean {
  const featureToggleService = inject(FeatureToggleService);
  const router = inject(Router);

  const data: FeatureToggleRouteData | undefined = route.data;

  if (!data?.featureFlag) {
    throw new Error('Provide feature flag via route data.');
  }

  const hasAccess = featureToggleService.isEnabled(data.featureFlag);

  if (hasAccess) {
    return true;
  }

  if (data.redirectUrl) {
    router.navigateByUrl(data.redirectUrl);
  }

  return false;
}
